import React from 'react';
import CircularProgress, { CircularProgressProps } from '@material-ui/core/CircularProgress';
import withThemeProvider from '../util/withThemeProvider';

const SolvSpinner = (props: CircularProgressProps) => <CircularProgress {...props} />;

export default withThemeProvider(SolvSpinner);
